export default __webpack_public_path__ + "static/logo-12af6f7d8b95b852622129c49d4ad7a1.svg";